import actions from './actions';

const {
  GET_PRODUCTS,
  GET_PRODUCTS_ERR,
  GET_PRODUCTS_BEGIN,
  CREATE_PRODUCT,
  CREATE_PRODUCT_BEGIN,
  CREATE_PRODUCT_ERR,
  GET_CATEGORIES,
  GET_CATEGORIES_ERR,
  GET_CATEGORIES_BEGIN,
  GET_OPTIONS,
  GET_OPTIONS_ERR,
  GET_OPTIONS_BEGIN,
  CREATE_OPTION,
  CREATE_OPTION_BEGIN,
  CREATE_OPTION_ERR,
  UPDATE_OPTION,
  UPDATE_OPTION_BEGIN,
  UPDATE_OPTION_ERR,
  DELETE_OPTION,
  DELETE_OPTION_BEGIN,
  DELETE_OPTION_ERR,
  GET_SELECTIONS,
  GET_SELECTIONS_BEGIN,
  GET_SELECTIONS_ERR,
  CREATE_SELECTION,
  CREATE_SELECTION_BEGIN,
  CREATE_SELECTION_ERR,
  UPDATE_SELECTION,
  UPDATE_SELECTION_BEGIN,
  UPDATE_SELECTION_ERR,
  DELETE_SELECTION,
  DELETE_SELECTION_BEGIN,
  DELETE_SELECTION_ERR,
} = actions;
const initState = {
  products: [],
  page: 1,
  totalResults: 0,
  limit: 0,
  loading: false,
  error: null,
  categories: [],
  options: [],
  selections: [],
  loadingCreate: false,
  loadingOption: false,
  loadingSelection: false,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const ProductsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_PRODUCTS:
      return {
        ...state,
        loading: false,
        products: data.results,
        totalResults: data.totalResults,
        limit: data.limit,
        page: data.page,
      };
    case GET_PRODUCTS_ERR:
      return {
        ...state,
        loading: false,
        error: err,
      };
    case GET_PRODUCTS_BEGIN:
      return {
        ...state,
        error: null,
        products: [],
        totalResults: initState.totalResults,
        limit: initState.limit,
        page: initState.page,
        loading: true,
      };
    case CREATE_PRODUCT:
      return {
        ...state,
        loadingCreate: false,
      };
    case CREATE_PRODUCT_BEGIN:
      return {
        ...state,
        loadingCreate: true,
      };
    case CREATE_PRODUCT_ERR:
      return {
        ...state,
        loadingCreate: false,
        error: err,
      };
    case GET_CATEGORIES:
      return {
        ...state,
        categories: data.results,
        error: err,
        loading: false,
      };
    case GET_CATEGORIES_BEGIN:
      return {
        ...state,
        categories: [],
        error: null,
        loading: false,
      };
    case GET_CATEGORIES_ERR:
      return {
        ...state,
        loading: false,
        error: err,
      };
    case GET_OPTIONS:
      return {
        ...state,
        options: data.results,
        error: err,
        loading: false,
      };
    case GET_OPTIONS_BEGIN:
      return {
        ...state,
        options: [],
        error: null,
        loading: false,
      };
    case GET_OPTIONS_ERR:
      return {
        ...state,
        loading: false,
        error: err,
      };

    // Option CRUD cases
    case CREATE_OPTION_BEGIN:
      return {
        ...state,
        loadingOption: true,
      };
    case CREATE_OPTION:
      return {
        ...state,
        loadingOption: false,
      };
    case CREATE_OPTION_ERR:
      return {
        ...state,
        loadingOption: false,
        error: err,
      };
    case UPDATE_OPTION_BEGIN:
      return {
        ...state,
        loadingOption: true,
      };
    case UPDATE_OPTION:
      return {
        ...state,
        loadingOption: false,
      };
    case UPDATE_OPTION_ERR:
      return {
        ...state,
        loadingOption: false,
        error: err,
      };
    case DELETE_OPTION_BEGIN:
      return {
        ...state,
        loadingOption: true,
      };
    case DELETE_OPTION:
      return {
        ...state,
        loadingOption: false,
        options: state.options.filter(option => option.id !== action.id),
      };
    case DELETE_OPTION_ERR:
      return {
        ...state,
        loadingOption: false,
        error: err,
      };

    // Selection CRUD cases
    case GET_SELECTIONS_BEGIN:
      return {
        ...state,
        selections: [],
        error: null,
        loadingSelection: true,
      };
    case GET_SELECTIONS:
      return {
        ...state,
        selections: data.results || data,
        error: err,
        loadingSelection: false,
      };
    case GET_SELECTIONS_ERR:
      return {
        ...state,
        loadingSelection: false,
        error: err,
      };
    case CREATE_SELECTION_BEGIN:
      return {
        ...state,
        loadingSelection: true,
      };
    case CREATE_SELECTION:
      return {
        ...state,
        loadingSelection: false,
      };
    case CREATE_SELECTION_ERR:
      return {
        ...state,
        loadingSelection: false,
        error: err,
      };
    case UPDATE_SELECTION_BEGIN:
      return {
        ...state,
        loadingSelection: true,
      };
    case UPDATE_SELECTION:
      return {
        ...state,
        loadingSelection: false,
      };
    case UPDATE_SELECTION_ERR:
      return {
        ...state,
        loadingSelection: false,
        error: err,
      };
    case DELETE_SELECTION_BEGIN:
      return {
        ...state,
        loadingSelection: true,
      };
    case DELETE_SELECTION:
      return {
        ...state,
        loadingSelection: false,
        selections: state.selections.filter(selection => selection.id !== action.id),
      };
    case DELETE_SELECTION_ERR:
      return {
        ...state,
        loadingSelection: false,
        error: err,
      };

    default:
      return state;
  }
};
export default ProductsReducer;
